var React = require('react');

function BtnArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","stroke":"currentColor","strokeWidth":".3","d":"M20.827 5.078l-3.83-3.886c-.223-.255-.654-.25-.905-.02-.25.229-.272.636-.019.863l2.806 2.851H1.64A.627.627 0 0 0 1 5.5c0 .339.286.614.638.614H18.88l-2.806 2.85c-.253.228-.233.637.02.866.251.23.687.23.904-.022l3.83-3.886A.586.586 0 0 0 21 5.5a.674.674 0 0 0-.173-.422z"}));
}

BtnArrow.defaultProps = {"width":"22","height":"11","viewBox":"0 0 22 11"};

module.exports = BtnArrow;

BtnArrow.default = BtnArrow;
